import { addDays } from 'date-fns';

export const UPCOMING_SESSION_RANGE_OPTIONS = [
  { value: 'today', label: 'Today', sort: 0 },
  { value: 'next7Days', label: 'Next 7 days', sort: 1 },
  { value: 'next14Days', label: 'Next 14 days', sort: 2 },
  { value: 'next30Days', label: 'Next 30 days', sort: 3 },
];

export const upcomingSessionShortcuts = [
  {
    label: 'Today',
    getValue: () => [new Date(), new Date()] as [Date, Date],
  },
  {
    label: 'Next 7 days',
    getValue: () => [new Date(), addDays(new Date(), 7)] as [Date, Date],
  },
  {
    label: 'Next 14 days',
    getValue: () => [new Date(), addDays(new Date(), 14)] as [Date, Date],
  },
  {
    label: 'Next 30 days',
    getValue: () => [new Date(), addDays(new Date(), 30)] as [Date, Date],
  },
];
